import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import { AppPage } from '../AppPage';
import { Card } from '../helpers/Card';
import { SearchInput } from './SearchInput';
import { SearchDropDown } from './SearchDropDown';
import { SearchResultHead } from './SearchResultHead';
import { SearchResultTable } from './SearchResultTable';

import style from './style.module.css';

/**
 * Search component.
 *
 * @param props {Object}.
 */
const SearchComponent = ({
  dropdownItems,
  hasAccess,
  onClick,
  onOnlyOwnerChange,
  onSearch,
  onSearchBy,
  onSearchingTermChange,
  searchBy,
  searchingTerm,
  userName,
  activeTab,
  totalCompanies,
  onTabChange,
  totalPeople,
  companies,
  onScroll,
  people,
  searchingCompanies,
  searchingPeople,
}) => {
  const isDisabledSearch = searchingTerm.trim() === '' || searchingCompanies || searchingPeople;

  const toolbar = (
    <>
      <SearchInput
        disabled={isDisabledSearch}
        hasAccess={hasAccess}
        onOnlyOwnerChange={onOnlyOwnerChange}
        onSearch={onSearch}
        onSearchBy={onSearchBy}
        onSearchingTermChange={onSearchingTermChange}
        searchBy={searchBy}
        searchingTerm={searchingTerm}
        userName={userName}
      />
      <div className={style.toolbar}>
        <SearchDropDown dropdownItems={dropdownItems} hasAccess={hasAccess} onClick={onClick} />
      </div>
    </>
  );

  return (
    <AppPage overline="Search" title="Companies & People" toolbar={toolbar}>
      <Card className={style.results} flush>
        <SearchResultHead
          activeTab={activeTab}
          companiesCount={totalCompanies}
          hasAccess={hasAccess}
          onTabChange={onTabChange}
          peopleCount={totalPeople}
        />
        <SearchResultTable
          activeTab={activeTab}
          companies={companies}
          hasAccess={hasAccess}
          onScroll={onScroll}
          people={people}
          searchingCompanies={searchingCompanies}
          searchingPeople={searchingPeople}
        />
      </Card>
    </AppPage>
  );
};

SearchComponent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  companies: PropTypes.instanceOf(List).isRequired,
  dropdownItems: PropTypes.instanceOf(List).isRequired,
  onClick: PropTypes.func.isRequired,
  onOnlyOwnerChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchingTermChange: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  people: PropTypes.instanceOf(List).isRequired,
  searchingCompanies: PropTypes.bool.isRequired,
  searchingPeople: PropTypes.bool.isRequired,
  searchingTerm: PropTypes.string.isRequired,
  totalCompanies: PropTypes.number.isRequired,
  totalPeople: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
};

export const Search = memo(SearchComponent);
